import { Event } from '@mui/icons-material';
import { CircularProgress, Grid, Typography } from '@mui/material';
import moment from 'moment';
import { createRef, useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';

require('../charts/bar-chart.js');

const GraficoVeiculosDia = ({campanha, meses, dias, periodoSelecionado, labelBarra, titulo, loading, containerMinHeight = '35vh', grafHeight = 130}) => {
  const graficoRef = createRef();

  const [graficoConfig, setGraficoConfig] = useState(undefined);
  const [isDiario, setIsDiario] = useState(campanha?.quantidadeMeses === 1);

  useEffect(() => {
    if (!graficoRef.current || !dias) return;

    const maxValue = Math.max(dias.map((d) => d.veiculos)?.reduce((a, b) => Math.max(a, b), 0) * 1.3, 200);
    const data = dias?.map((d) => parseInt(d.veiculos || 0));

    const ctx = graficoRef.current.chartInstance.ctx;
    const y1offset = graficoRef.current.chartInstance.height;
    const gradientBar = ctx.createLinearGradient(0, 0, 0, y1offset);

    gradientBar.addColorStop(0, '#006EC9');
    gradientBar.addColorStop(0.3, '#006EC9');
    gradientBar.addColorStop(1, '#00B3FF');

    setGraficoConfig({
      datasets: [
        {
          label: labelBarra,
          data,
          borderColor: gradientBar,
          fill: false,
          tension: 0,
        },
      ],
      maxValue: maxValue,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campanha, dias]);

  useEffect(() => {
    setIsDiario(campanha?.quantidadeMeses === 1 || periodoSelecionado);
  }, [campanha, meses, periodoSelecionado]);

  return (
    <Grid sx={styles.container} style={{minHeight: containerMinHeight}}>
      <Grid container item direction="row" alignItems="center">
        <Event sx={styles.totaisIcon} />
        <Typography sx={styles.totaisTitle}>
          {titulo} por {isDiario ? 'dia' : 'período'}
        </Typography>
      </Grid>
      <Grid sx={styles.graficoContainer} className={`graph-bar`}>
        {loading && (
          <Grid sx={styles.loadingContainer}>
            <CircularProgress sx={styles.loading} />
          </Grid>
        )}
        {dias && (
          <Line
            label={titulo}
            ref={graficoRef}
            data={{
              labels: dias?.map((d) => moment(d.data).format('DD/MM')),
              ...graficoConfig,
            }}
            height={grafHeight}
            width={800}
            options={{
              cornerRadius: 6,
              tooltips: {enabled: false},
              hover: {mode: null},
              legend: {display: false},
              scales: {
                xAxes: [
                  {
                    gridLines: {
                      drawOnChartArea: false,
                      display: false,
                    },
                    stacked: true,
                  },
                ],
                yAxes: [
                  {
                    gridLines: {
                      drawBorder: false,
                      drawOnChartArea: false,
                      display: false,
                    },
                    ticks: {
                      beginAtZero: true,
                      maxTicksLimit: 6,
                      display: false,
                      min: 0,
                      max: graficoConfig?.maxValue || 2000,
                    },
                    angleLines: {
                      display: false,
                    },
                  },
                ],
              },
              plugins: {
                datalabels: {
                  color: '#0008',
                  padding: '0',
                  align: 'end',
                  anchor: 'end',
                  rotation: dias?.length > 6 ? 345 : 0,
                  font: {
                    weight: 'bold',
                    size: dias?.length > 4 ? 10 : 14,
                  },
                  formatter: (value, {datasetIndex}) => {
                    if (2 === datasetIndex || value < 0) return '';

                    return value?.toLocaleString();
                  },
                },
              },
            }}
          />
        )}
      </Grid>
    </Grid>
  );
};

const styles = {
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '24px',
    borderRadius: '4px',
    background: '#fff',
    boxShadow: '0px 2px 12px 0px #0000001A',
    marginBottom: '16px',
  },
  totaisIcon: {
    color: '#031663',
    height: '20px',
    width: '20px',
    margin: '0 7px',
  },
  totaisTitle: {
    color: '#031663',
    fontSize: '18px',
    fontFamily: 'Poppins',
    fontWeight: '500',
  },
  graficoContainer: {
    position: 'relative',
    padding: '20px 0 10px 0',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  loadingContainer: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff6',
    width: '100%',
    height: '100%',
    zIndex: 2,
  },
  loading: {
    width: '30px !important',
    height: '30px !important',
  },
};

export default GraficoVeiculosDia;
